import styled from "styled-components";
import * as Variables from "./../globalStyles/Variables";
import Product from "./Product";
import { categoryType, productType } from "../utils/types";
import { AnimatePresence, motion } from "framer-motion";
import { useEffect, useRef, useState } from "react";
import { useRecoilState, useRecoilValue } from "recoil";
import { openCategories } from "../recoil/Atoms";
import { productsFetched } from "../recoil/Selectors";
import { analytics } from "../firebase.config";
import { logEvent } from "firebase/analytics";

export const CategoryContainer = styled.section`
  background: ${Variables.getColor().card};
  overflow: hidden;
  border-radius: 12px;
`;

const CategoryHeader = styled.button<{ isOpen: boolean }>`
  border: none;
  width: 100%;
  display: flex;
  position: relative;
  height: 20vw;
  min-height: 150px;
  background: transparent;
  outline: none;
  justify-content: center;
  align-items: center;
  padding-bottom: 40%;

  @media ${Variables.device.tablet}{
    max-height: 250px;
  }

  img {
    position: absolute;
    width: 100%;
    z-index: ${Variables.zIndex.two};
    height: 100%;
    top: 0;
    object-fit: cover;
    transition: ease-in-out 0.2s;
  }

  h2 {
    color:${Variables.getColor().textColor}d6;
    position: absolute;
    z-index: 3;
    font-size: 1.6rem;
    letter-spacing: 1px;
    text-transform: uppercase;
    transition: ease-in-out 0.2s;
    top: 16px;
    left: 16px;
    font-weight: 800;
    font-size: 3.3rem;
    opacity: 1;
  }
`;

const CategoryList = styled(motion.ul)`
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  z-index: ${Variables.zIndex.one};
`;

interface Props {
  category: categoryType;
}

const Category = (props: Props) => {
  const category = props.category;
  const myRef = useRef<HTMLUListElement>(null);
  const productsFetch = useRecoilValue<productType[]>(productsFetched);
  const [categoriesOpened, setCategoriesOpened] =
    useRecoilState<string[]>(openCategories);

  const [productsCategory, setproductsCategory] = useState<productType[]>();

  useEffect(() => {
    setproductsCategory(productsFetch?.filter((i) => i.category === category.slug))
  }, [category.slug, productsFetch]);


  const isCategoryOpen = categoriesOpened.includes(category.slug);

  const OpenCategory = () => {
    //myRef?.current?.scrollIntoView();

    logEvent(analytics, "view_item_list", { "category": category.slug })

    if (isCategoryOpen) {
      setCategoriesOpened(
        categoriesOpened.filter((item: string) => item !== category.slug)
      );
    } else {
      setCategoriesOpened([...categoriesOpened, category.slug]);
    }
  };


  return (
    <CategoryContainer>
      <CategoryHeader isOpen={isCategoryOpen} onClick={() => OpenCategory()} aria-label={category.name}>
        <img src={category.image} alt={category.name} loading="lazy" title={category.name} />
        <h2>{category.name}</h2>
      </CategoryHeader>
      <AnimatePresence initial={false}>
        {isCategoryOpen &&
        <CategoryList ref={myRef}
          initial="collapsed"
          animate={isCategoryOpen ? "open" : "collapsed"}
          exit="collapsed"
          variants={{
            open: { opacity: 1, height: "auto" },
            collapsed: { opacity: 0, height: 0 }
          }}
          transition={{ duration: 0.3, ease: [0.04, 0.62, 0.23, 0.98] }}
        >
          {productsCategory &&
            productsCategory.map((item) => {
              return <Product key={item.slug} product={item} />;
            })}
        </CategoryList>
}
      </AnimatePresence>
    </CategoryContainer>
  );
};

export default Category;
